<template>
  <div id="app">
    <div class="wrapper">
      <Header/>
      <router-link to="/">
      </router-link>
      <router-view/>
      <Footer/>
    </div>
    <FooterCopyRight/>
    <TopScroll/>
  </div>
</template>

<script>

import Header from './header'
import Footer from './footer'
import FooterCopyRight from './footer_copyright'
import TopScroll from './top_scroll'

export default {
  components : {
    Header,
    Footer,
    FooterCopyRight,
    TopScroll
  }
}
</script>

<style lang="scss">
* {
  margin:0;
  padding: 0;
  font-family: “ヒラギノ角ゴ Pro W3”, “Hiragino Kaku Gothic Pro”, メイリオ, Meiryo, Osaka, “ＭＳ Ｐゴシック“, “MS PGothic”, sans-serif;

  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #000000;
    margin-top: 18px;

    // フォントサイズ
    h1 {
      font-size: 24px;
      line-height: 1.5;
    }
    h2 {
      font-size: 21px;
      line-height: 1.5;
    }
    p {
      font-size: 16px;
      line-height: 1.6;
    }
    li, dd {
      font-size: 16px;
      line-height: 1.6;
    }

    button {
      cursor: pointer;
    }

    // 以下、SP（スマホ以下）
      @media all and (max-width: 767px) {
        margin-top: 13px;
      }

    .wrapper {
      max-width: 1060px;
      margin: 0 10px  auto;
      display: inline-block;
      text-align: center;

      // リンク
      // a, a:link, a:visited, a:active { 
      //   color: #000000;
      // }
      // a:hover { 
      //   color: #bd1717;
      //   text-decoration: none;
      // }


      // 以下、SP（スマホ以下）
      @media all and (max-width: 767px) {
        // width: 96vh;
        // margin-left: 2vh;
        // margin-right: 2vh;

        // フォントサイズ
        h1 {
          font-size: 22px;
          line-height: 1.5;
        }
        h2 {
          font-size: 18px;
          line-height: 1.5;
        }
        p {
          font-size: 15px;
          line-height: 1.6;
        }
        li, dd {
          font-size: 15px;
          line-height: 1.6;
        }
      }
    }
  }
}
</style>
